import { useGetCurrentUserQuery } from "@/shared/services";
import { useEffect } from "react";
import { useImportRegistry } from "../stores/import-registry.store";
import { ImportStoreProvider } from "../stores/import-store-context";
import { useIsImportDialogOpen } from "../utils/import-dialog-id";
import { ImportRunner } from "./import-runner";
import { usePersistImports } from "./use-persist-imports";
import { useResumeImports } from "./use-resume-imports";

// Mounted in SetupProvider so it outlives every route, the editor included:
// one runner per import keeps polling, persistence and its toasts going.
export const FileToStorydocGenerationManager = () => {
  const imports = useImportRegistry((s) => s.imports);
  const dialogOpen = useIsImportDialogOpen();
  const { data: user } = useGetCurrentUserQuery();
  const userId = user?._id ?? null;
  // declared first: the registry belongs to this user before resume and persistence run
  useEffect(() => useImportRegistry.getState().bindOwner(userId), [userId]);
  useResumeImports(userId);
  usePersistImports(userId);

  if (imports.length === 0) return null;
  return (
    <div className="tw-pointer-events-none tw-fixed tw-bottom-6 tw-right-6 tw-z-[100000] tw-flex tw-flex-col tw-gap-2 [&>*]:tw-pointer-events-auto">
      {imports.map((entry) => (
        <ImportStoreProvider key={entry.id} store={entry.store}>
          <ImportRunner id={entry.id} hidden={dialogOpen} />
        </ImportStoreProvider>
      ))}
    </div>
  );
};
